(() => {
  const detailsSelector = 'details[data-dt-mobile-models]';

  function groupFor(details) {
    return window.DaveTechMenuData?.get(details.dataset.dtMenuSource);
  }

  function populate(details) {
    if (!details || details.dataset.dtMobileModelsState === 'ready') return;

    const list = details.querySelector('[data-dt-mobile-model-list]');
    const group = groupFor(details);
    if (!list || !group) {
      list?.removeAttribute('aria-busy');
      return;
    }

    const fragment = document.createDocumentFragment();
    const idPrefix = (details.dataset.dtMenuSource || 'models').replace(/[^a-z0-9_-]+/gi, '-');
    const items = Array.isArray(group.items) && group.items.length ? group.items : [group];

    items.forEach((item, index) => {
      const listItem = document.createElement('li');
      const link = document.createElement('a');
      link.id = `HeaderDrawerDynamic-${idPrefix}-${index + 1}`;
      link.href = item.url;
      link.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset';
      link.textContent = item.title;
      if (item.current) {
        link.setAttribute('aria-current', 'page');
        link.classList.add('menu-drawer__menu-item--active');
      }
      listItem.appendChild(link);
      fragment.appendChild(listItem);
    });

    list.replaceChildren(fragment);
    list.removeAttribute('aria-busy');
    details.dataset.dtMobileModelsState = 'ready';
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const summary = event.target.closest(`${detailsSelector} > summary`);
    if (summary) populate(summary.parentElement);
  });

  document.addEventListener(
    'toggle',
    (event) => {
      if (event.target instanceof Element && event.target.matches(detailsSelector) && event.target.open) {
        populate(event.target);
      }
    },
    true
  );
})();
